import { lastValueFrom } from 'rxjs';
import { getBackendSrv } from '@grafana/runtime';
import { handleRequestError } from '../../utils/utils.mjs';

"use strict";
function createBaseQuery({ baseURL }) {
  async function backendSrvBaseQuery(requestOptions) {
    var _a, _b, _c;
    try {
      const headers = {
        ...requestOptions.headers
      };
      if (((_a = requestOptions.method) == null ? void 0 : _a.toUpperCase()) === "PATCH" && (baseURL == null ? void 0 : baseURL.startsWith("/apis/"))) {
        if (requestOptions.body && Array.isArray(requestOptions.body) && requestOptions.body.some((item) => item.op)) {
          headers["Content-Type"] = "application/json-patch+json";
        }
        if (!headers["Content-Type"]) {
          headers["Content-Type"] = "application/strategic-merge-patch+json";
        }
      }
      const { data: responseData, ...meta } = await lastValueFrom(
        getBackendSrv().fetch({
          ...requestOptions,
          url: baseURL + requestOptions.url,
          // Default to GET so backend_srv correctly skips success alerts for queries
          method: (_b = requestOptions.method) != null ? _b : "GET",
          showErrorAlert: (_c = requestOptions.showErrorAlert) != null ? _c : false,
          data: requestOptions.body,
          headers
        })
      );
      return { data: responseData, meta };
    } catch (error) {
      if (requestOptions.manageError) {
        return requestOptions.manageError(error);
      } else {
        return handleRequestError(error);
      }
    }
  }
  return backendSrvBaseQuery;
}

export { createBaseQuery };
//# sourceMappingURL=createBaseQuery.mjs.map
